import React from 'react';
import styles from './App.module.css';
import { HashRouter,Route,Switch } from 'react-router-dom';
import {LoginPage} from './pages/login/Login';
import {Home} from './pages/home/Home';

import moment from 'moment';
import 'moment/locale/zh-cn';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';

function App() {
  moment.locale('zh-cn');
  return (
    <div className={styles.App}>
      <ConfigProvider locale={zhCN}>
      <HashRouter>
        <Switch>
          <Route exact path="/" component={LoginPage} />          
          <Route path="/home" component={Home} />          
          <Route render={() => <h1>404 not found ！</h1>} />
        </Switch>
      </HashRouter>
      </ConfigProvider>
    </div>
  );
}

export default App;
